export { default as CustomerList } from './Listar'
export { default as CreateCustomer } from './Crear'